import { Component, inject, input } from '@angular/core';

import { ModalService } from '../../../services';
import { SummaryTopComponent } from '../../summary-top/summary-top.component';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrl: './delete-modal.component.scss',
  imports: [SummaryTopComponent],
})
export class DeleteModalComponent {
  private readonly modalService = inject(ModalService);

  public readonly header = input($localize`Delete`);
  public readonly message = input($localize`Are you sure you want to delete this item?`);

  onDelete() {
    this.modalService.close();
  }

  onCancel() {
    this.modalService.dismiss();
  }
}
